import { useEffect } from 'react';
import { useNavigate, useLocation } from '@usas/ui-web/wrappers/ReactRouterDom';

import { navLinks } from '../../../UseNavLinks';

import useExistingClubRegistrationData from '../../../state/workflow/existingClubRegistration/UseExistingClubRegistrationData';

import Constants from '@usas/ui-web/utils/Constants';

const useExistingClubRegistration = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { existingClubRegistrationState, getExistingClubRegistration } = useExistingClubRegistrationData();

  const onRegistrationClicked = (e, clubReg) => {
    if (e && e.preventDefault) {
      e.preventDefault();
    }

    navigate(navLinks.EXISTING_CLUB_REGISTRATION_APPROVALS, { state: { clubReg, isRevisit: location.state?.isRevisit } });
  };

  useEffect(() => {
    if (existingClubRegistrationState.isArrayLoaded !== true) {
      if (location.state && location.state?.isRevisit === true) {
        getExistingClubRegistration(true);
      }
      else {
        getExistingClubRegistration(false);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return {
    location,
    Constants,
    existingClubRegistrationState,
    onRegistrationClicked
  };
};

export default useExistingClubRegistration;